import React, { ReactElement } from 'react';
import './CheckboxControl.scss';

export default function CheckboxControl(props: Props) {
	return (
		<div className="checkbox-control__container">
			<div className="checkbox-control__checkbox" 
				 onClick={props.onClick} 
				 onKeyPress={onKeyPress} 
				 tabIndex={0} 
				 role="checkbox" 
				 aria-checked={props.checked} 
				 aria-label={props.label ?? ''}>
				{props.checked && <div className="checkbox-control__checkbox-check"></div>}
			</div>
			{!!props.label && <span onClick={props.onClick}>{props.label}</span>}
			{props.children}
		</div>
	);

	function onKeyPress(e: React.KeyboardEvent) {
		if (e.key === ' ') {
			props.onClick();
			e.preventDefault();
		}
	}
}

interface Props {
    checked: boolean;
    onClick: () => void;
    label?: string;
    children?: ReactElement;
}